import { Theme } from '@yandex-int/k-common/typings';
import {
    withRouterPath,
    InjectedProps as WithRouterPathProps,
    mediaQueryResolver,
    SCREEN_SIZE,
    WithMediaQueryResolverProps,
} from 'platform-components/hocs';
import qs from 'query-string';
import React from 'react';
import { connect } from 'react-redux';

import { getCurrentClass } from 'common.components/user/selectors';
import * as themeSelectors from 'store/themes/selectors';

// @ts-ignore
import BREAKPOINTS from '../../../../../design/breakpoints.scss';
import { ReduxTeacherStore } from '../../../typings';
import Themes from '../../library.sidebar-themes/sidebar-themes';
import { SCREEN_QUERY } from '../constants';

interface StoreProps {
    plainThemes: Array<Theme>;
    theme?: Theme;
    shouldShowActualThemes: boolean;
}

interface HOCProps extends WithRouterPathProps, WithMediaQueryResolverProps {}

interface Props extends StoreProps, HOCProps {}

export class SidebarNav extends React.Component<Props> {
    render = () => {
        const {
            match: {
                params: { themeId, subject: selectedSubject },
            },
            theme: selectedTheme,
            plainThemes,
            screenSize,
            shouldShowActualThemes,
        } = this.props;

        const shouldShowThemes = selectedSubject && (!themeId || (selectedTheme && !selectedTheme.parent));
        const shouldShowPlain = shouldShowThemes && plainThemes.length > 0;

        if (!shouldShowPlain) {
            return null;
        }

        return (
            <Themes
                isMobile={screenSize === SCREEN_SIZE.SMALL}
                mix="qa_nonpromo-themes"
                shouldAddActualThemes={shouldShowActualThemes}
                themes={plainThemes}
            />
        );
    };
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps): StoreProps => {
    const {
        location: { search },
        match: {
            params: { classId, subject, themeId: thId },
        },
    } = ownProps;
    const query = qs.parse(search);
    const themeId = Number(thId);
    const currentTeam = getCurrentClass(storeState, { classId });
    const grade = currentTeam?.level || Number(query.grade);

    return {
        theme: themeSelectors.getThemeById(storeState, { subject, grade, themeId }),
        plainThemes: themeSelectors.getPlainThemes(storeState, { subject, grade }),
        shouldShowActualThemes: themeSelectors.getShouldShowActualThemes(storeState, { classId, subject }),
    };
};

export default mediaQueryResolver([], BREAKPOINTS, SCREEN_QUERY)(withRouterPath(connect(mapStateToProps)(SidebarNav)));
